import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addTodo, updateTodo } from '../../features/TodoSlice'

import { v4 as uuidv4 } from 'uuid';
import { RootState } from '../../app/store';

const TaskForm = ({onSubmitForm, id = null} : any) => {
    const existedTask = useSelector((state : RootState) => state.todos.find(item => item.id === id))

    const [title, setTitle] = useState<any>('')
    const [description, setDescription] = useState<any>('')
    const [deadline, setDeadline] = useState<any>('')
    const [disabled, setDisabled] = useState<any>(true)
    
    const dispatch = useDispatch()
    
    useEffect(() => {
        getDate()

        if(id) {
            setTitle(existedTask?.title)
            setDescription(existedTask?.description)
            setDeadline(existedTask?.deadline)
        }
    }, [])

    useEffect(() => {
        handleDisableState()
    }, [title, description])

    const getDate = ()  => {
        const today = new Date()
        const formattedDate = `${ String(today.getFullYear()) }-${ String((today.getMonth() + 1)).padStart(2,'0') }-${String(today.getDate()).padStart(2,'0')}`
        setDeadline(formattedDate)   
    }

    const handleDisableState = () => {
        let allFieldsFalse = title !== '' && description !== ''

        if ( allFieldsFalse ) {
            setDisabled(false)
        }
        else {
            setDisabled(true)
        }
    }

    const handleAddTodo = (ev : any) => {
        ev.preventDefault()
        if (id) {
            dispatch(updateTodo({
                id,
                title,
                description,
                deadline,
            }))
        }
        else {
            dispatch(addTodo({
                id: uuidv4(),
                title,
                description,
                deadline,
                status: 'new'
            }))
        }
        
        setTitle('')
        onSubmitForm()
    }

    return (
        <form data-testid="todo_form" onSubmit={handleAddTodo}>
            <div className="todo_form__group">

                <div className="form_control">
                    <label htmlFor="title">Title</label>
                    <input 
                        type="text" 
                        data-testid="todo_input" 
                        value={title}
                        onChange={(ev: any) => setTitle(ev.target.value)}
                        placeholder='Title'
                        id='title'
                    />
                </div>

                <div className="form_control">
                    <label htmlFor="description">Description</label>
                    <textarea 
                        name="description" 
                        id="description" 
                        cols={30}
                        rows={10} 
                        placeholder="Description"
                        value={description}
                        onChange={(ev: any) => setDescription(ev.target.value)}
                    />
                </div>

                <div className="form_control">
                    <label htmlFor="deadline">Deadline</label>
                    <input type="date" value={deadline} onChange={(ev : any) => {
                        setDeadline(ev.target.value)
                    }}/>
                </div>

                <button className='todo_submit' disabled={disabled} style={{marginTop: 15}}>Submit</button>
            </div>
        </form>
    )
}

export default TaskForm